import type { TFunction } from '@/i18n';

export const initRequiredFieldMessageGetter =
  (t: TFunction<'common'>) => (fieldLabel: string) =>
    t('fieldErrors.fieldIsRequired', { fieldLabel });

export const initMaxCharacterLimitMessageGetter =
  (t: TFunction<'common'>) => (max: number) =>
    t('fieldErrors.maxCharacterLimit', { max });
